module.exports = __webpack_public_path__ + "assets/img/2610.99ded72b.png";